import { Divider } from "antd";
import { Header } from "antd/es/layout/layout";
import styled from "styled-components";

export const StyledHeader = styled(Header)`
  height: 4.75rem;
  display: flex;
  align-items: center;

  background-color: ${({ theme }) => theme.colors.white};

  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
  z-index: 500;
`;

export const StyledDivider = styled(Divider)`
  && {
    border-color: black;
    margin: 0;
    font-size: 2.75rem;
    letter-spacing: 0.25rem;
    font-weight: 200;
    text-transform: uppercase;
  }
`;

export const StyledLabel = styled.span`
  transition: color 0.3s ease;
  
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    cursor: pointer;
  }
`;
